// Dependencies
import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction'
import thunk from 'redux-thunk'
import logger from 'redux-logger'

// Reducer
import global from '_reducers'

const initialState = {}

// Middlewares
const middlewares = [ thunk, ]
const middleware = (
  process.env.REACT_APP_ENV === 'production' &&
  process.env.REACT_APP_IS_LOCAL !== true ?
  middlewares :
  [ ...middlewares, require('redux-immutable-state-invariant').default(), logger ]
)


export default createStore(
  global,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
)
